// extracted by mini-css-extract-plugin
export default {"button":"style_button__6Wo1f","saved":"style_saved__T-dOa"};